import ApiService from "../api.service";
import appConfig from "../../../app-config";

ApiService.init(appConfig.VUE_APP_ROOT_API);

const CustomerFreightChargeService = {
  async getByCode(code) {
    const requestScreenData = {
      url: "api/CustomerSalesContractFreightCharge",
      top: "1000",
      filter: `CustomerCode eq '${code}'`,
    };

    return await ApiService.oDataGet(requestScreenData);
  },
  async getByRecordId(recordId) {
    const requestScreenData = {
      url: "api/CustomerSalesContractFreightCharge",
      expand: "Customer($select=Code,Name)",
      top: "1",
      filter: `RecordId eq ${recordId}`,
    };

    return await ApiService.oDataGet(requestScreenData);
  },

  dataSourceConfig(url, params) {
    return ApiService.createDataSource(url, params);
  },
  async save(mode, customerSalesContractFreightCharge) {
    var payload = customerSalesContractFreightCharge;
    var url = "api/CustomerSalesContractFreightCharge";

    if (mode == "create") {
      return await ApiService.post(url, payload, "Guid");
    } else {
      return await ApiService.patch(
        url,
        customerSalesContractFreightCharge.RecordId,
        payload,
        "Guid"
      );
    }
  },
  async delete(customerSalesContractFreightCharge) {
    var url = "api/CustomerSalesContractFreightCharge";

    return await ApiService.delete(
      url,
      customerSalesContractFreightCharge.RecordId,
      "Guid",
      customerSalesContractFreightCharge
    );
  },
};

export { CustomerFreightChargeService };
